module.exports = __webpack_public_path__ + "img/nut_allergy-off.14c8bb71.svg";